
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 bg-white shadow-md"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between">
          <a href="#home" className="cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/ba6bcb6e46a4fb76c5fa17ca5b486c21/2ad90636716f2bbd7235399cef4dd72b.png" 
              alt="McCrea's Landscaping & Irrigation"
              className="h-20 w-auto max-w-full object-contain object-left"
            />
          </a>

          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#services"
              className="text-sm font-medium transition-colors cursor-pointer text-gray-700 hover:text-emerald-600"
            >
              Services
            </a>
            <a
              href="#portfolio"
              className="text-sm font-medium transition-colors cursor-pointer text-gray-700 hover:text-emerald-600"
            >
              Portfolio
            </a>
            <a
              href="#about"
              className="text-sm font-medium transition-colors cursor-pointer text-gray-700 hover:text-emerald-600"
            >
              About
            </a>
            <a
              href="#contact"
              className="text-sm font-medium transition-colors cursor-pointer text-gray-700 hover:text-emerald-600"
            >
              Contact
            </a>
            <a
              href="tel:3347826042"
              className="flex items-center space-x-2 px-5 py-2.5 bg-emerald-600 text-white rounded-full hover:bg-emerald-700 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              <span>(334) 782-6042</span>
            </a>
          </div>

          <button 
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-gray-900`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <div 
        className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-white px-6 py-4 space-y-4 border-t border-gray-100">
          <a
            href="#services"
            onClick={closeMobileMenu}
            className="block text-gray-700 hover:text-emerald-600 font-medium cursor-pointer"
          >
            Services
          </a>
          <a
            href="#portfolio"
            onClick={closeMobileMenu}
            className="block text-gray-700 hover:text-emerald-600 font-medium cursor-pointer"
          >
            Portfolio
          </a>
          <a
            href="#about"
            onClick={closeMobileMenu}
            className="block text-gray-700 hover:text-emerald-600 font-medium cursor-pointer"
          >
            About
          </a>
          <a
            href="#contact"
            onClick={closeMobileMenu}
            className="block text-gray-700 hover:text-emerald-600 font-medium cursor-pointer"
          >
            Contact
          </a>
          <a
            href="tel:3347826042"
            className="flex items-center justify-center space-x-2 px-5 py-3 bg-emerald-600 text-white rounded-full hover:bg-emerald-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            <span>(334) 782-6042</span>
          </a>
        </div>
      </div>
    </nav>
  );
}
